import { Autocomplete, FormControl, FormLabel, TextField } from '@mui/material';

import { useDAL } from '@/contexts/useDAL';

import { EmptySelect } from './emptySelect';

const title = 'VPC';

export const VpcSelect = ({
  accountId,
  regionName,
  vpc,
  onChange,
  disabledItems,
}: {
  accountId?: string;
  regionName?: string;
  vpc?: string;
  onChange: (vpc: string) => void;
  disabledItems: string[];
}) => {
  if (!accountId || !regionName) {
    return <EmptySelect title={title} />;
  }

  return (
    <InnerVpcSelect
      accountId={accountId}
      regionName={regionName}
      vpc={vpc}
      onChange={onChange}
      disabledItems={disabledItems}
    />
  );
};

const InnerVpcSelect = ({
  accountId,
  regionName,
  vpc,
  onChange,
  disabledItems,
}: {
  accountId: string;
  regionName: string;
  vpc?: string;
  onChange: (vpc: string) => void;
  disabledItems: string[];
}) => {
  const dal = useDAL();
  const { data: body } = dal.restore.awsSubnets.useList(accountId, regionName);

  if (!body?.subnets.length) {
    return <EmptySelect title={title} />;
  }

  const options = Array.from(
    new Set(body.subnets.map((value) => value.vpc))
  ).sort();

  return (
    <FormControl size='small' className='flex-1'>
      <FormLabel>{title}</FormLabel>
      <Autocomplete
        data-testid='vpcSelect'
        clearOnBlur
        size='small'
        value={vpc || null}
        onChange={(event, newValue) => onChange(newValue || '')}
        getOptionDisabled={(option) => disabledItems.includes(option)}
        renderInput={(params) => {
          return (
            <TextField
              {...params}
              placeholder='Select'
              label=''
              InputLabelProps={{ shrink: true }}
            />
          );
        }}
        options={options}
      />
    </FormControl>
  );
};
